<template>
    <article class="page page-404">
        <div ref="canvas-container" class="scene-404"></div>
    </article>
</template>

<script>

// Utils
import params from '../../utils/params'
import MyEmitter from '../../helpers/MyEmitter'

// Scene
import Scene404 from '../../helpers/threejs/scenes/Scene404'


export default {
    components: {
    },
    name: "Page404",
    beforeDestroy: function(){

        // on mobile there is no scene
        this.scene && this.scene.destroy()
    },
    beforeRouteLeave(to, from, next){
        this.scene._animateExit(() => {
            next()
        })
    },
    mounted: function(){

        this.scene = new Scene404(this.$refs["canvas-container"], {
            
        }, {
            mobileDetected: this.$root.mobileDetected,
        })
        this.scene.init()
        this.scene.start()

        // wait ressources
        MyEmitter.emit(params.Events.appHasLoadedRessources)
    }
}
</script>

<style lang="scss">
    .page-404{

        .scene-404{
            @include absolute-fullscreen();
            z-index: 0;
        }
    }
</style>